import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, User, HeartHandshake, MapPin, BookOpen } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { useScreenInit } from '../../useScreenInit';
export function SelectUserType() {
  useScreenInit();
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState<string | null>(null);
  const userTypes = [{
    id: 'beneficiary',
    title: 'Beneficiary',
    description: 'I want to grow my business and access support.',
    icon: User,
    color: 'text-brand-primary',
    bg: 'bg-brand-primary/10'
  }, {
    id: 'sponsor',
    title: 'Sponsor',
    description: 'I want to fund and support entrepreneurs.',
    icon: HeartHandshake,
    color: 'text-brand-secondary',
    bg: 'bg-brand-secondary/10'
  }, {
    id: 'agent',
    title: 'Field Agent',
    description: 'I verify and monitor beneficiaries on the ground.',
    icon: MapPin,
    color: 'text-brand-accent',
    bg: 'bg-brand-accent/10'
  }, {
    id: 'trainer',
    title: 'Trainer',
    description: 'I provide educational content and mentorship.',
    icon: BookOpen,
    color: 'text-brand-success',
    bg: 'bg-brand-success/10'
  }];
  const handleContinue = () => {
    if (selectedType === 'beneficiary') {
      navigate('/terms'); // Route to terms before onboarding
    } else {
      // For now, route others to a placeholder or back
      navigate('/terms');
    }
  };
  return <div className="min-h-screen bg-brand-background flex flex-col" data-id="element-174">
      <header className="px-4 py-4 flex items-center bg-white sticky top-0 z-10 border-b border-gray-100" data-id="element-175">
        <button onClick={() => navigate(-1)} className="p-2 -ml-2 text-text-secondary hover:text-text-primary" data-id="element-176">
          <ChevronLeft className="w-6 h-6" data-id="element-177" />
        </button>
        <h1 className="text-lg font-bold text-text-primary ml-2" data-id="element-178">
          Select Account Type
        </h1>
      </header>

      <main className="flex-1 px-6 py-8" data-id="element-179">
        <h2 className="text-2xl font-heading font-bold text-text-primary mb-2" data-id="element-180">
          How do you want to use FortuneBridge?
        </h2>
        <p className="text-text-secondary text-sm mb-8" data-id="element-181">
          Choose the option that best describes your role.
        </p>

        <div className="space-y-4" data-id="element-182">
          {userTypes.map(type => {
          const isSelected = selectedType === type.id;
          return <Card key={type.id} interactive onClick={() => setSelectedType(type.id)} className={`border-2 transition-all ${isSelected ? 'border-brand-primary bg-brand-primary/5 shadow-md' : 'border-transparent'}`} data-id="element-183">
                <div className="flex items-start" data-id="element-184">
                  <div className={`p-3 rounded-xl mr-4 ${isSelected ? 'bg-brand-primary text-white' : type.bg + ' ' + type.color}`} data-id="element-185">
                    <type.icon className="w-6 h-6" data-id="element-186" />
                  </div>
                  <div className="flex-1" data-id="element-187">
                    <h3 className={`font-bold text-base mb-1 ${isSelected ? 'text-brand-primary' : 'text-text-primary'}`} data-id="element-188">
                      {type.title}
                    </h3>
                    <p className="text-sm text-text-secondary" data-id="element-189">
                      {type.description}
                    </p>
                  </div>
                  <div className={`w-5 h-5 rounded-full border-2 mt-1 flex items-center justify-center ${isSelected ? 'border-brand-primary' : 'border-gray-300'}`} data-id="element-190">
                    {isSelected && <div className="w-2.5 h-2.5 rounded-full bg-brand-primary" data-id="element-191" />}
                  </div>
                </div>
              </Card>;
        })}
        </div>
      </main>

      <div className="p-6 bg-white border-t border-gray-100" data-id="element-192">
        <Button fullWidth size="lg" disabled={!selectedType} onClick={handleContinue} data-id="element-193">
          Continue
        </Button>
      </div>
    </div>;
}